"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreativeWork = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
//import {Thing} from './Thing';
const schema_1 = require("../ontologies/schema");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const Shape_1 = require("lincd/lib/shapes/Shape");
let CreativeWork = class CreativeWork extends Shape_1.Shape {
    get creditText() {
        return this.getValue(schema_1.schema.creditText);
    }
    set creditText(val) {
        this.overwrite(schema_1.schema.creditText, new models_1.Literal(val));
    }
    //@TODO: remove this once weve got a better solution for circular dependencies (see Thing get/set Image)
    /**
     * The name of the item.
     */
    get name() {
        return this.getValue(schema_1.schema.name);
    }
    set name(val) {
        this.overwrite(schema_1.schema.name, new models_1.Literal(val));
    }
    get usageInfo() {
        return this.getValue(schema_1.schema.usageInfo);
    }
    set usageInfo(val) {
        this.overwrite(schema_1.schema.usageInfo, new models_1.Literal(val));
    }
    get copyrightNotice() {
        return this.getValue(schema_1.schema.copyrightNotice);
    }
    set copyrightNotice(val) {
        this.overwrite(schema_1.schema.copyrightNotice, new models_1.Literal(val));
    }
};
CreativeWork.targetClass = schema_1.schema.CreativeWork;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.creditText,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CreativeWork.prototype, "creditText", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.name,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CreativeWork.prototype, "name", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.usageInfo,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CreativeWork.prototype, "usageInfo", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.copyrightNotice,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CreativeWork.prototype, "copyrightNotice", null);
CreativeWork = __decorate([
    package_1.linkedShape
], CreativeWork);
exports.CreativeWork = CreativeWork;
//# sourceMappingURL=CreativeWork.js.map